import './style.scss';
import Event from 'f.core.event'
import tmpl from './main.ejs'
import {videoEvents} from './videoEvents.js'; 

class AdCore {
    constructor(opt) {
        this.opt = opt;
        this.init(opt)
    };

    init(opt) {
        this.event = new Event();
        this.initLayout(opt);
    };
    //布局
    initLayout({ data, obj }) {
        console.dir(data);

        const adcore = {
            adUrls: data.video_Url,
            durations: data.totol_Time
        };
        this.el = $(tmpl(adcore));
        this.exitDom = this.el.find('.c-adPaster__exitBox');
        this.time = this.el.find('.c-adPaster__time span');
        this.mute = this.el.find('.c-adPaster__mute');
        this.more = this.el.find('.c-adPaster__more');
        this.video = this.el.find('video');
        this.video[0].style.display = 'block';

        let ua = navigator.userAgent,
            isIos = ua.match(/iphone|ipod/ig);

        if (isIos) {
            this.mute.hide();
        }
        console.log('绑上了！');
        this.exitDom[0].addEventListener('touchend', () => {
            console.log('点到了！');
            this.event.trigger('exit');
            return false;
        });

        // debugger;
        // this.video[0].addEventListener('canplay', function () {
        //     console.log('1111');
        // })

    };

    //播放
    adPlay(index) {
        if (index > 0) {
            this.video[index - 1].style.display = 'none';
        }
        this.video[index].style.display = 'block';
        this.video[index].play();

        this.dom = this.video[index];
        this.clickUrl = this.opt.data.video_Link[index];
    };

    adPause(index) {
        this.video[index].pause();
    };

    adLoad(index) {
        if (index > 0) {
            this.video[index - 1].style.display = 'none';
        }
        this.video[index].style.display = 'block';
        this.video[index].load();
    }

    //静音
    adVolume(ele) {
        for (let i = 0, length1 = this.video.length; i < length1; i++) {
            this.video[i].volume = this.video[i].volume == 0 ? 1 : 0;
            // if (this.video[i].volume === 1) {
            //     this.video[i].volume = 0;
            //     this.video[i].muted = 'muted';
            // } else {
            //     this.video[i].volume = 1;
            // }
            console.log(this.video[i].volume);
        }
        this.mute.toggleClass('muted');

    };

    destory() {
        this.el.remove();
    };

    hide() {
        this.el.hide();
    };

    show() {
        this.el.show();
    };

    renderTo(parentNode) {
        $(parentNode).append(this.el);
    };

    on(eventName, callback, ele) {
        if (videoEvents.indexOf(eventName) >= 0) {
            ele.addEventListener(eventName, callback, false);
        } else {
            this.event.on(eventName, callback);
        }
    };

    off(eventName, callback, ele) {
        if (videoEvents.indexOf(eventName) >= 0) {
            ele.removeEventListener(eventName, callback);
        } else {
            this.event.off(eventName, callback);
        }
    };


}


 //Event.mixTo(AdCore);
export default AdCore;



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.component.ad.mobile/app/modules/AdCore/index.js